import { takeLatest } from 'redux-saga/effects';

import { CustomerDetilsSaga } from './customerSaga';
import sagaActions from '../../actions/index';

export function* customerListSaga() {
  yield takeLatest(sagaActions.GET_CUSTOMER_DETILS, CustomerDetilsSaga);
}
